import { Component, HostListener, Input, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import * as Immutable from 'immutable';
import { ConfigurationLoader } from 'shared/configuration-loader';
import { Configuration } from 'shared/models/configuration';
import { FormatGroup, MaterialType } from '../../../entity/models/entity';
import { DictionaryTypes } from '../../../models/dictionaries';
import { DictionariesService } from '../../../services/dictionaries.service';
import { ItemDetail } from '../../models/custom-events';
import { CustomerI, Page } from '../../models/page';
import { DiscoverV2BffService } from '../../service/discover-v2-bff.service';
import { TranslateService } from '@ngx-translate/core';
import { select, Store } from '@ngrx/store';
import { getRapidoMode } from 'search/reducers/root.reducer';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-grid-view-v2',
  templateUrl: './grid-view-v2.component.html',
})

export class GridViewV2Component implements OnInit, OnDestroy {
  @Input() public entities: FormatGroup[];
  public page: Page = null;
  public config: Configuration;
  public materialTypes: Immutable.Map<string, MaterialType>;
  public customer: CustomerI = null;
  public translations: any = {};
  public isRapidoMode = false;
  private subscriptions = new Subscription();

  constructor(
    private readonly router: Router,
    private configLoader: ConfigurationLoader,
    private readonly dictionariesService: DictionariesService,
    private discoverV2BffService: DiscoverV2BffService,
    private translateService: TranslateService,
    private readonly store: Store
  ) {
    this.config = this.configLoader.config;
    this.customer = this.discoverV2BffService.customer;
    this.materialTypes = this.dictionariesService.getDictionaryItem(DictionaryTypes.MATERIAL_TYPES) as Immutable.Map<string, MaterialType>;
    this.page = this.discoverV2BffService.$page.value;

    this.translations = {
      tabsAvailable: this.translateService.instant('tabsAvailable'),
      tabsCheckAvailability: this.translateService.instant('tabsCheckAvailability'),
      tabsCheckedOut: this.translateService.instant('tabsCheckedOut'),
      tabsOnOrder: this.translateService.instant('tabsOnOrder'),
      tabsUnavailable: this.translateService.instant('tabsUnavailable')
    };
  }

  ngOnInit() {
    this.subscriptions.add(
      this.store.pipe(select(getRapidoMode)).subscribe((rapidoMode) => {
        this.isRapidoMode = rapidoMode;
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  @HostListener('window:itemClicked', ['$event'])
  public onItemClicked(event: CustomEvent) {
    const {id, entityType}: ItemDetail = event.detail;
    this.router.navigate(['/search', 'card'], {
      queryParams: {
        id,
        entityType,
        ...(this.isRapidoMode && { rapido: true })
      }
    });
  }
}
